module.exports = __webpack_public_path__ + "media/city_skyline.b031e8d2.jpg";